// ECZE COLOR PALLETTE
export const colors = {
	primary: '#00DAD3',
	secondary: '#E7CDBD',
	almostWhite: '#F5F5F5',
	almostBlack: '#2F2F2F',
	white: '#fff'
}
